/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import { BlockBlobClient } from '@azure/storage-blob';
export type AttachmentsToUpload = {
  id: string;
  destination: string;
  filename: string;
  tinyurl: string;
  signature: string;
};
export const signatureHash = async (message: string) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(message);
  const buffer = await crypto.subtle.digest('SHA-256', data);
  return Array.prototype.map.call(new Uint8Array(buffer), (x) => ('00' + x.toString(16)).slice(-2)).join('');
};

const uploadToAzureStorage = async (
  sasUri: string,
  documentId: string,
  filename: string,
  blobName: string,
  blob: File | undefined,
  url: string = '',
  progress?: (value: number, uploaded: number, uploadTotal: number) => void
) => {
  const blobClient = new BlockBlobClient(sasUri);

  if (blob) {
    const uploadOptions = {
      blobHTTPHeaders: { blobContentType: blob.type },
      onProgress: (ev: any) => {
        progress?.((ev.loadedBytes / blob.size) * 100, ev.loadedBytes, blob.size);
      },
    };

    const b = await blob.arrayBuffer();
    await blobClient.uploadData(b, uploadOptions);
  } else if (url) {
    await blobClient.beginCopyFromURL(url);
  }

  await blobClient.setMetadata({ documentId, filename });
};
export const uploadAllAttachments = async (
  apiAttachments: AttachmentsToUpload[],
  filesBySignature: Map<string, File>
) => {
  for (const att of apiAttachments) {
    const file = filesBySignature.get(att.signature);

    if (!file) {
      console.warn('Missing file for signature:', att.signature);
      continue;
    }
    await uploadToAzureStorage(att.destination, '', att.filename || file.name, att.tinyurl, file, '');
  }
};
